import {useMutation} from 'react-query';
import {emailService} from '../../../../shared/services/configuration/email';
import {IPaginateProducts} from 'src/shared/common-dtos/get-all-paginate';

export const useGetEmails = (paginate?: IPaginateProducts) => {
  return useMutation(
    async () => {
      return await emailService.getEmails(paginate);
    },
    {
      mutationKey: ['allEmails', paginate],
    },
  );
};
